import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['Insegni chimica nella scuola secondaria di secondo grado.', 'Vuoi ridurre il tempo dedicato alla ricerca e alla preparazione.', 'Cerchi materiali visivi, strutturati e pronti all\'uso.', 'Hai bisogno di teoria, attività, verifiche e soluzioni in un unico sistema.'];
const notForYou = ['Stai cercando un videocorso o una certificazione accademica.', 'Preferisci creare ogni risorsa completamente da zero.', 'Cerchi un prodotto fisico già stampato e spedito a casa.'];
export function AudienceSection() {
  return <section className="w-full bg-paper px-5 py-6 sm:py-12" data-id="element-23" data-mp="98sctnv94ry2">
      <div className="mx-auto grid max-w-5xl gap-4 sm:gap-6 md:grid-cols-2" data-id="element-24" data-mp="e13eav5n4lsq">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-cobalt/20 bg-[#EEF4FF] p-6 sm:p-8" data-id="element-25" data-mp="3cr3e5ukz2ryo">
          <h3 className="mb-6 text-lg font-bold text-cobalt-deep sm:text-xl" data-id="element-26" data-mp="zbpvhe7pva2i">
            ✅ CHIMICA VISIVA™ fa per te se…
          </h3>
          <ul className="space-y-4" data-id="element-27" data-mp="ujy1sut9ko85">
            {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-28" data-mp="qjxlt5qio4yz">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-29" data-mp="qhl6z1g22aq5">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-30" data-mp="gkovcmuv18hd" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-31" data-mp="bllqp3isl49x">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="rounded-2xl border border-red-100 bg-[#FFF5F5] p-6 sm:p-8" data-id="element-32" data-mp="7mcu7qwdasao">
          <h3 className="mb-6 text-lg font-bold text-ink sm:text-xl" data-id="element-33" data-mp="3vfz0qrf8qqzb">
            ❌ CHIMICA VISIVA™ non fa per te se…
          </h3>
          <ul className="space-y-4" data-id="element-34" data-mp="3mgvg3j0fe3ip">
            {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-35" data-mp="3mesfy65k6u09">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-36" data-mp="3qj08kef50u3r">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-37" data-mp="i0avaekp2zzu" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-38" data-mp="mzdydth46w56">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}